import { NewMessageFormData } from '@src/main/modules/messages/ui/mailbox/components/new-message/types/NewMessageFormData';
import { FileUpload } from 'primereact/fileupload';
import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface Props {
  control: Control<NewMessageFormData>;
  styles: Record<string, string>;
}

export const AttachmentField: FC<Props> = ({ control, styles }) => {
  const { t } = useTranslation();

  return (
    <div className={styles['form-section']}>
      <label>{t('messages.mailbox.attachment')}</label>
      <Controller
        name="file"
        control={control}
        render={({ field }) => (
          <>
            <FileUpload
              name="file"
              chooseLabel={t('common.attachFile')}
              mode="advanced"
              auto
              multiple={false}
              maxFileSize={600000}
              onSelect={(e) => {
                const file = e.files[0];
                field.onChange(file);
              }}
              invalidFileSizeMessageSummary={t('common.validation.invalidFileSizeSummary', {
                filename: '{0}',
              })}
              invalidFileSizeMessageDetail={t('common.validation.invalidFileSizeDetail', {
                maxSize: '600 KB',
              })}
            />
          </>
        )}
      />
    </div>
  );
};
